import fetch from './AxiosAdapter';
import axios from 'axios';
import UsuarioStore from '../store/UsuarioStore';
import Configuracao from '../misc/Configuracao';

class ServidorApi {

    //TODO retirar as any
    async buscarServidoresPJe(orgao): Promise<any> {
        const result = await fetch(Configuracao.urlUsuariosGE + orgao + '/listaUsuariosOrgaoJulgador');
        const servidores = result.data as any;

        servidores.sort((servidor1, servidor2) => {
            if (servidor1.nome < servidor2.nome) {
                return -1;
            }
            if (servidor1.nome > servidor2.nome) {
                return 1;
            }
            return 0;
        });
        return servidores;
    }

    async buscarServidoresPJeSecretarias(descricaoLocalizacao): Promise<any> {
        const result = await fetch(Configuracao.urlUsuariosGE + descricaoLocalizacao + '/listaUsuariosPorDescricaoLocalizacao');
        const servidores = result.data as any;
        return servidores;
    }

    //MANTEM
    //TODO retirar as any
    async buscarInformacoesUsuario(cpfUsuario): Promise<any> {
        const result = await fetch(Configuracao.urlUsuarios + cpfUsuario + '/informacoes');
        const dadosUsuario = result.data;
        return dadosUsuario;
    }

    async buscarOrgaoJulgador(localizacao): Promise<any> {
        const token = UsuarioStore.token;

        const response = await axios.get(Configuracao.urlOrgaoJulgador + localizacao, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });

        return response.data;
    }

    async msConsultaUsuarios(cpfUsuario: string, configOverride = {}): Promise<any> {
        const result = await fetch(Configuracao.urlMsConsultaUsuarios + cpfUsuario, {
            ...configOverride
        });
        return result.data;
    }

    async msConsultaUsuariosBatch(cpfs: string[], configOverride = {}): Promise<any> {
        const result = await fetch(Configuracao.urlMsConsultaUsuarios, {
            body: cpfs,
            method: 'POST',
            ...configOverride
        });
        return result.data;
    }

}

export default new ServidorApi();
